import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useNavigate, Link } from 'react-router-dom';
import Footer from "./Footer";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Add_CheckZMCMConveyance = () => {
    const [profile, setProfile] = useState(null);
    const [punchData, setPunchData] = useState([]);

    const [punchDetailsMap, setPunchDetailsMap] = useState({});
    const [othersCount, setOthersCount] = useState(0);
    const [loadingPunches, setLoadingPunches] = useState(true);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [details, setDetails] = useState([]);
    const [filterDate, setFilterDate] = useState("");
    const [filterBranch, setFilterBranch] = useState("");
    const [filterDevice, setFilterDevice] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedPunches, setSelectedPunches] = useState({});
    const [empRemarks, setEmpRemarks] = useState("");
    const [visitSummary, setVisitSummary] = useState(null);

    const [visitRows, setVisitRows] = useState([]);
    const normalizeBranchName = (name = "") => {
        return name
            .toLowerCase()
            .replace(/[0-9]/g, "")        // remove numbers
            .replace(/[^a-z\s]/g, "")    // remove symbols (-, _, etc.)
            .replace(/\s+/g, " ")        // normalize spaces
            .trim();
    };
    const getMonthRange = () => {
        const now = new Date();

        const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

        const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const previousMonth = `${prev.getFullYear()}-${String(prev.getMonth() + 1).padStart(2, "0")}`;

        return { currentMonth, previousMonth };
    };
    const { currentMonth, previousMonth } = getMonthRange();
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
    });
    const [allBranches, setBranches] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const navigate = useNavigate();

    const normalizeDate = (dateStr) => {
        return dateStr?.split(" ")[0]; // always YYYY-MM-DD
    };
    const enteredAmount = visitRows.reduce((sum, row) => {
        return row.date ? sum + Number(row.amount || 0) : sum;
    }, 0);
    const handleAddOthers = () => {
        const newKey = `OTHERS_${othersCount}`;

        const newRow = {
            type: "others",
            DeviceId: newKey,      // fake device
            LogDate: "",           // manual date optional
            DeviceFNAME: "",       // branch
            PunchTimes: "",        // not used
        };

        setPunchData(prev => [...prev, newRow]);
        setOthersCount(prev => prev + 1);
    };

    const handleRemoveOthers = (rowKey) => {
        // Remove row from punchData
        setPunchData(prev =>
            prev.filter(row => row.DeviceId !== rowKey)
        );

        // Remove related selectedPunches
        setSelectedPunches(prev => {
            const updated = { ...prev };
            delete updated[rowKey];
            return updated;
        });
    };

    function getBranchNumber(name = "") {
        const match = name.match(/\d+/);
        if (!match) return null;
        return parseInt(match[0], 10); // removes leading zero (095 → 95)
    }
    // const currentMonth = new Date().toLocaleString("en-US", { month: "long" });
    // Load profile first
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await fetch(`${API_BASE_URL}profile`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                const result = await res.json();
                if (result.status && result.profile) {
                    setProfile(result.profile);
                    fetchDetails(result.profile.emp_code);
                } else {
                    setMessage("Unable to load profile");
                    setLoading(false);
                }
            } catch (error) {
                setMessage("Failed to load profile");
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);


    const fetchPunches = async (month) => {
        try {
            setLoadingPunches(true);

            const token = localStorage.getItem("authToken");

            const res = await fetch(`https://travelapp.vdcapp.in/backend/api/get_punches_for_user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    selected_month: month
                }),
            });

            const result = await res.json();

            if (result.status && result.data) {
                setPunchData(result.data);
            } else {
                setPunchData([]);
            }

        } catch (error) {
            console.error("Punch fetch error:", error);
            toast.error("Failed to load punch data");
        } finally {
            setLoadingPunches(false);
        }
    };

    useEffect(() => {
        if (selectedMonth) {
            fetchPunches(selectedMonth);
        }
    }, [selectedMonth]);


    // Fetch details
    const fetchDetails = async (empCode) => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${API_BASE_URL}getcmzmdetails/${empCode}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            const result = await response.json();

            if (result.status && result.data.status === "success") {
                const row = result.data.data[0];
                setDetails([row]);

                const branchArray = row.branches_list || [];
                const role = row.role;

                // 🔹 Decide visits per branch based on role
                const visitsPerBranch =
                    role === "cluster_manager" ? 2 : 1;

                // 🔹 Total visits
                const totalVisits = branchArray.length * visitsPerBranch;


                // 🔹 Amount split
                const totalAmount = parseFloat(row.amount);
                setTotalAmount(totalAmount);
                const perVisitAmount = totalAmount / totalVisits;
                const displayAmount = Number(perVisitAmount).toFixed(2);
                const visits = [];

                branchArray.forEach((b) => {
                    for (let visitNo = 1; visitNo <= visitsPerBranch; visitNo++) {
                        visits.push({
                            visit_no: visitNo,
                            branch_id: b.id,
                            branch_name: b.name,
                            date: "",
                            from_time: "",
                            to_time: "",
                            day: "",
                            purpose: "",
                            remarks: "",
                            amount: 0,
                            attachment: null,
                        });
                    }
                });

                setVisitRows(visits);
            } else {
                setMessage(result.data?.message || "No conveyance records found");
            }
        } catch (err) {
            setMessage("Failed to load conveyance details");
        } finally {
            setLoading(false);
        }
    };



    const getSelectedMonthYear = () => {
        return selectedMonth; // YYYY-MM
    };

    const getSelectedMonthYear1 = () => {
        const [year, month] = selectedMonth.split("-");
        const date = new Date(year, month - 1);

        return date.toLocaleString("en-US", {
            month: "short",
            year: "numeric",
        });
    };

    const handleSubmit = async (type = "draft") => {

        if (Object.keys(selectedPunches).length === 0) {
            alert("Please add punch or others details");
            return;
        }

        // 🚨 Check attachment for Others rows
        for (const [key, value] of Object.entries(selectedPunches)) {

            if (value.type === "others") {

                if (!value.attachment) {
                    alert("Attachment is mandatory for Others entry");
                    return;
                }

            }

        }

        // ✅ CONFIRMATION ONLY FOR FINAL SUBMIT
        if (type === "approval") {
            const confirmSubmit = window.confirm(
                "Once submitted, you will not be able to edit this data. Continue?"
            );

            if (!confirmSubmit) {
                return; // ❌ stop submission
            }
        }

        // validations...

        // ✅ MOVE THIS HERE (BEFORE try)
        const punchPayload = Object.entries(selectedPunches).map(([key, value]) => {

            const isOthers = value.type === "others";
            const [deviceId, logDate] = key.split("_");

            const punchRow = !isOthers
                ? punchData.find(
                    p => p.DeviceId === deviceId && p.LogDate === logDate
                )
                : null;

            const calculateDuration = (from, to) => {
                if (!from || !to) return "";
                const [fh, fm] = from.split(":").map(Number);
                const [th, tm] = to.split(":").map(Number);
                const diff = (th * 60 + tm) - (fh * 60 + fm);
                if (diff <= 0) return "";
                return `${Math.floor(diff / 60)}h ${diff % 60}m`;
            };
            const amountKey = isOthers
                ? key
                : `${deviceId}_${logDate}`;

            return {
                date: isOthers ? value.date : logDate,
                branch: isOthers ? value.branch : punchRow?.DeviceFNAME || "",
                device: isOthers ? null : deviceId,
                comp_name: profile.comp_name,
                punch_times: isOthers ? "" : punchRow?.PunchTimes || "",
                from: value.from || "",
                to: value.to || "",
                duration: calculateDuration(value.from, value.to),
                amount: isOthers
                    ? Number(value.amount || 0)
                    : (visitAmountMap[amountKey] || 0),
                remarks: value.remarks || "",
                reason: isOthers ? (value.reason || "") : "",
                entry_type: isOthers ? "others" : "punch",
                attachment: value.attachment || null
            };
        });

        try {
            const token = localStorage.getItem("authToken");
            const formData = new FormData();

            // ✅ NOW ESLINT IS HAPPY
            formData.append("punches", JSON.stringify(punchPayload));

            formData.append("emp_remarks", empRemarks);

            formData.append(
                "is_submitted",
                type === "approval" ? "Y" : "N"
            );

            punchPayload.forEach((row, index) => {
                if (row.attachment) {
                    formData.append(`attachment_${index}`, row.attachment);
                }
            });

            const res = await fetch(`${API_BASE_URL}add_punch_times`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            const result = await res.json();
            if (result.status === false) {
                // 🔥 THIS WILL SHOW YOUR MESSAGE
                alert(result.message);
                return;
            }

            if (result.status) {
                toast.success(
                    type === "approval"
                        ? "Submitted for approval successfully"
                        : "Draft saved successfully"
                );
                navigate("/manage_checkcmzmconveyance");
            } else {
                toast.error(result.message || "Failed to save");
            }

        } catch (error) {
            console.error(error);
            toast.error("Server error");
        }
    };







    const branchIndexMap = {};
    let branchCounter = 0;

    visitRows.forEach((row) => {
        if (!branchIndexMap[row.branch_name]) {
            branchIndexMap[row.branch_name] = branchCounter;
            branchCounter++;
        }
    });

    const formatDateLocal = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };





    if (loading) {
        return <h3 style={{ padding: 20, color: "#6ca0dc" }}>Loading...</h3>;
    }

    const filteredPunchData = punchData.filter(row => {

        // ✅ Always allow "Others" rows
        if (row.type === "others") {
            return true;
        }

        // 🔹 Normal punch rows
        const matchDate = filterDate
            ? row.LogDate === filterDate
            : true;

        const matchBranch = filterBranch
            ? row.DeviceFNAME === filterBranch
            : true;

        const matchDevice = filterDevice
            ? String(row.DeviceId).includes(filterDevice)
            : true;

        return matchDate && matchBranch && matchDevice;
    });


    const calculateDuration = (from, to) => {
        if (!from || !to) return "";

        const [fh, fm] = from.split(":").map(Number);
        const [th, tm] = to.split(":").map(Number);

        const start = fh * 60 + fm;
        const end = th * 60 + tm;

        if (end <= start) return "Invalid";

        const diff = end - start;
        const hrs = Math.floor(diff / 60);
        const mins = diff % 60;

        return `${hrs}h ${mins}m`;
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const topSectionBranches =
        details[0]?.branches_list?.map(b => ({
            original: b.name,
            branchNo: getBranchNumber(b.name)
        })) || [];

    const branchVisitCounter = {};

    const visitAmountMap = {};
    const validVisitKeys = [];
    validVisitKeys.forEach((key, index) => {
        visitAmountMap[key] =
            index < remainder
                ? perVisitAmount + 1
                : perVisitAmount;
    });

    console.log("✅ Only V1/V2 Amount Map:", visitAmountMap);




    // ✅ STEP 1 — Find only V1 & V2 visits
    const visitLabelCounter = {};


    filteredPunchData.forEach(row => {

        if (row.type === "others") return;

        const branchName = row.DeviceFNAME || "";
        const punchBranchNo = getBranchNumber(branchName);

        const matchedTopBranch = topSectionBranches.find(tb =>
            tb.branchNo === punchBranchNo
        );

        if (!matchedTopBranch) return;

        const branchKey = matchedTopBranch.normalized;

        visitLabelCounter[branchKey] =
            (visitLabelCounter[branchKey] || 0) + 1;

        // ✅ ONLY V1 & V2
        if (visitLabelCounter[branchKey] <= 2) {
            validVisitKeys.push(`${row.DeviceId}_${row.LogDate}`);
        }
    });


    // ✅ STEP 2 — Amount Distribution
    const totalAmt = Number(totalAmount || 0);



    // 27 from API (Total Branches)
    // const totalBranches = Number(details[0]?.["1_30_cnt"] || 0);

    // if (details[0]?.["role"] === "cluster_manager") {
    //     totalBranches = totalBranches * 2;
    // }

    // if (details[0]?.["role"] != "cluster_manager") {
    //     totalBranches = totalBranches * 2;
    // }

    // let perVisitAmount = 0;
    // let remainder = 0;

    // if (totalBranches > 0) {
    //     perVisitAmount = (totalAmt / totalBranches).toFixed(2);
    // }


    let totalBranches = Number(details[0]?.["1_30_cnt"] || 0);

    const role = details[0]?.["role"];

    // ✅ Multiply only for cluster_manager
    if (role === "cluster_manager") {
        totalBranches = totalBranches * 2;
    }

    let perVisitAmount = 0;
    let remainder = 0;

    if (totalBranches > 0) {
        perVisitAmount = (totalAmt / totalBranches).toFixed(2);
    }



    validVisitKeys.forEach((key, index) => {
        visitAmountMap[key] =
            index < remainder
                ? perVisitAmount + 1
                : perVisitAmount;
    });

    console.log("✅ Final Amount Map:", visitAmountMap);

    // ✅ Console output



    return (
        <div className="hold-transition sidebar-mini layout-fixed"
            style={{ background: "#f4f7fb", fontSize: '12px' }}>
            <div className="wrapper">

                <Header />
                <Sidebar />

                <div className="content-wrapper" style={{ padding: "25px" }}>

                    {/* PAGE TITLE */}
                    <h2 style={{
                        color: "#6ca0dc",
                        fontWeight: "800",
                        fontSize: "24px",
                        marginBottom: "12px"
                    }}>
                        Fixed Conveyance
                    </h2>

                    {/* MESSAGE */}
                    {message && (
                        <div style={{
                            padding: "12px",
                            background: "#fdeeee",
                            borderLeft: "4px solid #d87a7a",
                            borderRadius: "8px",
                            marginBottom: "18px",
                            color: "#8b3f3f",
                        }}>
                            {message}
                        </div>
                    )}

                    {/* PROFILE CARD */}


                    {details.length > 0 && profile && (
                        <div
                            style={{
                                background: "#ffffffee",
                                padding: "18px 22px",
                                borderRadius: "12px",
                                border: "1px solid #d9e3f1",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                                marginBottom: "25px"
                            }}
                        >
                            {/* ===== Single Top Row ===== */}
                            {details.map((row, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: "30px",
                                        marginBottom: "10px",
                                        paddingBottom: "10px",
                                        borderBottom: "1px dashed #dbe3ef",
                                        fontSize: "14px",
                                        color: "#425b70",
                                    }}
                                >
                                    <span>
                                        <b style={{ color: "#557a95" }}>Employee:</b>{" "}
                                        {profile.comp_name} ({profile.emp_code})
                                    </span>

                                    <span>
                                        <b>Selected Month:</b> {getSelectedMonthYear1()}
                                    </span>

                                    <span>
                                        <b>Role:</b> {row.role}
                                    </span>

                                    <span>
                                        <b>Total Branches:</b> {row["1_30_cnt"]}
                                    </span>

                                    <span>
                                        <b>Amount:</b> {row["amount"]}
                                    </span>

                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <label style={{ fontWeight: "600" }}>Change Month:</label>
                                        <input
                                            type="month"
                                            value={selectedMonth}
                                            min={previousMonth}
                                            max={currentMonth}
                                            onChange={(e) => setSelectedMonth(e.target.value)}
                                            style={{
                                                padding: "6px 10px",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc"
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}

                            {/* ===== Branches Row ===== */}
                            {details.map((row, idx) => (
                                <div
                                    key={`branches-${idx}`}
                                    style={{
                                        fontSize: "14px",
                                        color: "#425b70",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    <b>Branches:</b>{" "}
                                    {row.branches_list && row.branches_list.length > 0
                                        ? row.branches_list
                                            .slice() // avoid mutating original array
                                            .sort((a, b) => a.name.localeCompare(b.name)) // 🔤 alphabetical sort
                                            .map(b => b.name)
                                            .join(", ")
                                        : "N/A"}
                                </div>
                            ))}

                        </div>
                    )}

                    {/* VISIT RECORDS */}
                    {/* PUNCH DETAILS */}
                    <div style={{
                        background: "#fff",
                        padding: "15px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                    }}>
                        <div style={tableScrollWrapper}>

                            <div style={{
                                display: "flex",
                                gap: "15px",
                                padding: "10px",
                                marginBottom: "15px",
                                flexWrap: "wrap"
                            }}>
                                {/* Date Filter */}
                                <input
                                    type="date"
                                    value={filterDate}
                                    onChange={(e) => setFilterDate(e.target.value)}
                                    style={{ padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
                                />

                                {/* Branch Filter */}
                                <select
                                    value={filterBranch}
                                    onChange={(e) => setFilterBranch(e.target.value)}
                                    style={{ padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
                                >
                                    <option value="">All Branches</option>
                                    {[...new Set(punchData.map(p => p.DeviceFNAME))].map((branch, i) => (
                                        <option key={i} value={branch}>{branch}</option>
                                    ))}
                                </select>
                                <span style={{ paddingTop: "10px", color: "red" }}>*The amount shown may not be the exact amount you will receive. The final amount will be determined by the Internal Audit team according to our VDC business rules.</span>

                            </div>

                            {loadingPunches ? (
                                <div style={{ padding: "20px", textAlign: "center" }}>
                                    ⏳ Loading punch data...
                                </div>
                            ) : (
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr style={{ background: "#f1f5f9" }}>
                                            <th style={thStyle}>Date</th>
                                            <th style={thStyle}>Branch</th>
                                            {/* <th style={thStyle}>Device</th> */}
                                            <th style={thStyle}>Punch Times</th>
                                            <th style={thStyle}>From</th>
                                            <th style={thStyle}>To</th>
                                            <th style={thStyle}>Duration</th>
                                            <th style={thStyle}>Amount</th>
                                            <th style={thStyle}>Remarks</th>
                                            <th style={thStyle}>Attachment</th>
                                            <th style={thStyle}>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredPunchData.map((row, idx) => {

                                            // ✅ DEFINE HERE (THIS WAS MISSING)
                                            const isOthers = row.type === "others";

                                            const key = isOthers
                                                ? row.DeviceId
                                                : `${row.DeviceId}_${row.LogDate}`;

                                            const punches = row.PunchTimes
                                                ? row.PunchTimes.split(",").map(p => p.trim())
                                                : [];

                                            return (
                                                <tr key={key}>
                                                    {/* DATE */}
                                                    <td style={tdStyle}>
                                                        {isOthers ? (
                                                            <input
                                                                type="date"
                                                                value={selectedPunches[key]?.date || ""}
                                                                max={new Date().toISOString().split("T")[0]}   // 👈 blocks future dates
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            date: e.target.value,
                                                                            type: "others"
                                                                        }
                                                                    }))
                                                                }
                                                            />
                                                        ) : (
                                                            formatDate(row.LogDate)
                                                        )}
                                                    </td>


                                                    <td style={tdStyle}>
                                                        {isOthers ? (
                                                            <select
                                                                value={selectedPunches[key]?.branch || ""}
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            branch: e.target.value,
                                                                            type: "others",
                                                                            reason:
                                                                                e.target.value === "Others"
                                                                                    ? prev[key]?.reason || ""
                                                                                    : ""
                                                                        }
                                                                    }))
                                                                }
                                                            >
                                                                <option value="">Select Branch</option>

                                                                {[...new Set(
                                                                    punchData
                                                                        .filter(p => p.type !== "others")
                                                                        .map(p => p.DeviceFNAME)
                                                                        .filter(Boolean)
                                                                )].map((b, i) => (
                                                                    <option key={i} value={b}>{b}</option>
                                                                ))}

                                                                <option value="Others">Others</option>
                                                            </select>
                                                        ) : (
                                                            (() => {
                                                                const branchName = row.DeviceFNAME || "";
                                                                const punchBranchNo = getBranchNumber(branchName);

                                                                const matchedTopBranch = topSectionBranches.find(tb =>
                                                                    tb.branchNo === punchBranchNo
                                                                );

                                                                if (!matchedTopBranch) {
                                                                    return <span>{branchName}</span>;
                                                                }

                                                                const key = punchBranchNo;

                                                                if (!branchVisitCounter[key]) {
                                                                    branchVisitCounter[key] = 1;
                                                                } else {
                                                                    branchVisitCounter[key] += 1;
                                                                }

                                                                const visitLabel = `V${branchVisitCounter[key]}`;

                                                                return (
                                                                    <span>
                                                                        {branchName}{" "}
                                                                        <b style={{ color: "#2563eb" }}>({visitLabel})</b>
                                                                    </span>
                                                                );
                                                            })()

                                                        )}
                                                    </td>





                                                    {/* PUNCH TIMES */}
                                                    <td style={tdStyle}>
                                                        {isOthers ? "-" : row.PunchTimes}
                                                    </td>

                                                    {/* FROM */}
                                                    <td style={tdStyle}>
                                                        {isOthers ? (
                                                            <input
                                                                type="time"
                                                                value={selectedPunches[key]?.from || ""}
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            from: e.target.value
                                                                        }
                                                                    }))
                                                                }
                                                            />
                                                        ) : (
                                                            <select
                                                                value={selectedPunches[key]?.from || ""}
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            from: e.target.value
                                                                        }
                                                                    }))
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {punches.map((p, i) => (
                                                                    <option key={i} value={p}>{p}</option>
                                                                ))}
                                                            </select>
                                                        )}
                                                    </td>

                                                    {/* TO */}
                                                    <td style={tdStyle}>
                                                        {isOthers ? (
                                                            <input
                                                                type="time"
                                                                value={selectedPunches[key]?.to || ""}
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            to: e.target.value
                                                                        }
                                                                    }))
                                                                }
                                                            />
                                                        ) : (
                                                            <select
                                                                value={selectedPunches[key]?.to || ""}
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            to: e.target.value
                                                                        }
                                                                    }))
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {punches.map((p, i) => (
                                                                    <option key={i} value={p}>{p}</option>
                                                                ))}
                                                            </select>
                                                        )}
                                                    </td>

                                                    {/* DURATION */}
                                                    <td style={tdStyle}>
                                                        {calculateDuration(
                                                            selectedPunches[key]?.from,
                                                            selectedPunches[key]?.to
                                                        )}
                                                    </td>

                                                    <td style={tdStyle}>
                                                        {isOthers ? (
                                                            calculateDuration(
                                                                selectedPunches[key]?.from,
                                                                selectedPunches[key]?.to
                                                            ) ? (
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Amount"
                                                                    value={selectedPunches[key]?.amount || ""}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;

                                                                        // allow numbers only
                                                                        if (/^\d*$/.test(val)) {
                                                                            setSelectedPunches(prev => ({
                                                                                ...prev,
                                                                                [key]: {
                                                                                    ...prev[key],
                                                                                    amount: val
                                                                                }
                                                                            }));
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: "90px",
                                                                        padding: "4px",
                                                                        borderRadius: "4px",
                                                                        border: "1px solid #ccc"
                                                                    }}
                                                                />
                                                            ) : "-"
                                                        ) : (
                                                            (() => {
                                                                const branchName = row.DeviceFNAME || "";
                                                                const punchBranchNo = getBranchNumber(branchName);

                                                                const matchedTopBranch = topSectionBranches.find(
                                                                    tb => tb.branchNo === punchBranchNo
                                                                );

                                                                if (!matchedTopBranch) return "-";

                                                                const visitNumber = branchVisitCounter[punchBranchNo] || 0;

                                                                // show amount only for V1 and V2
                                                                if (visitNumber === 1 || visitNumber === 2) {
                                                                    return (
                                                                        <>
                                                                            ₹ {perVisitAmount}
                                                                            <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                        </>
                                                                    );
                                                                }

                                                                return "-";
                                                            })()
                                                        )}
                                                    </td>

                                                    {/* REMARKS */}
                                                    <td style={tdStyle}>
                                                        {/* Normal remarks */}
                                                        <textarea
                                                            placeholder="Remarks"
                                                            value={selectedPunches[key]?.remarks || ""}
                                                            onChange={(e) =>
                                                                setSelectedPunches(prev => ({
                                                                    ...prev,
                                                                    [key]: {
                                                                        ...prev[key],
                                                                        remarks: e.target.value
                                                                    }
                                                                }))
                                                            }
                                                            rows={1}
                                                            style={{ width: "150px" }}
                                                        />

                                                        {/* ✅ Reason field only if Branch = Others */}
                                                        {isOthers && selectedPunches[key]?.branch === "Others" && (
                                                            <textarea
                                                                placeholder="Enter reason (mandatory)"
                                                                value={selectedPunches[key]?.reason || ""}
                                                                onChange={(e) =>
                                                                    setSelectedPunches(prev => ({
                                                                        ...prev,
                                                                        [key]: {
                                                                            ...prev[key],
                                                                            reason: e.target.value
                                                                        }
                                                                    }))
                                                                }
                                                                rows={2}
                                                                style={{
                                                                    width: "150px",
                                                                    marginTop: "6px",
                                                                    border: "1px solid #ef4444",
                                                                    background: "#fff7f7"
                                                                }}
                                                            />
                                                        )}
                                                    </td>


                                                    {/* ATTACHMENT */}
                                                    <td style={tdStyle}>
                                                        <input
                                                            type="file"
                                                            required={isOthers}
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (!file) return;
                                                                if (file.size > 1024 * 1024) {
                                                                    toast.error("File must be < 1MB");
                                                                    e.target.value = "";
                                                                    return;
                                                                }
                                                                setSelectedPunches(prev => ({
                                                                    ...prev,
                                                                    [key]: {
                                                                        ...prev[key],
                                                                        attachment: file
                                                                    }
                                                                }));
                                                            }}
                                                        />
                                                        {isOthers && !selectedPunches[key]?.attachment && (
                                                            <div style={{ color: "red", fontSize: "11px" }}>
                                                                * Attachment required
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={tdStyle}>
                                                        {isOthers && (
                                                            <button
                                                                onClick={() => handleRemoveOthers(key)}
                                                                style={{
                                                                    width: "28px",
                                                                    height: "28px",
                                                                    borderRadius: "50%",
                                                                    background: "#ef4444",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    cursor: "pointer",
                                                                    fontSize: "18px",
                                                                    fontWeight: "700",
                                                                    lineHeight: "27px",
                                                                    textAlign: "center",
                                                                    padding: "0"
                                                                }}
                                                                title="Remove"
                                                            >
                                                                –
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>

                                </table>
                            )}
                        </div>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "20px"
                        }}
                    >

                        {/* Left side - Remarks */}
                        <div>
                            <textarea
                                placeholder="Enter Employee Remarks"
                                value={empRemarks}
                                onChange={(e) => setEmpRemarks(e.target.value)}
                                rows={2}
                                style={{
                                    padding: "10px 14px",
                                    fontSize: "14px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    width: "250px",
                                    resize: "both"
                                }}
                            />
                        </div>


                        {/* Center Buttons */}
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                            }}
                        >

                            <button
                                onClick={() => navigate("/manage_checkcmzmconveyance")}
                                style={{
                                    background: "#6c757d",
                                    color: "#fff",
                                    padding: "12px 36px",
                                    borderRadius: "10px",
                                    border: "none",
                                    fontWeight: "700",
                                    cursor: "pointer"
                                }}
                            >
                                ❌ Cancel
                            </button>

                            <button
                                onClick={() => handleSubmit("draft")}
                                style={{
                                    background: "#4f7df3",
                                    color: "#fff",
                                    padding: "12px 36px",
                                    borderRadius: "10px",
                                    border: "none",
                                    fontWeight: "700",
                                    cursor: "pointer"
                                }}
                            >
                                💾 Save as Draft
                            </button>

                            <button
                                onClick={() => handleSubmit("approval")}
                                style={{
                                    background: "#34a853",
                                    color: "#fff",
                                    padding: "12px 36px",
                                    borderRadius: "10px",
                                    border: "none",
                                    fontWeight: "700",
                                    cursor: "pointer"
                                }}
                            >
                                🚀 Send for Approval
                            </button>

                        </div>


                        {/* Right side - Add Others */}
                        <div>
                            <button
                                onClick={handleAddOthers}
                                style={{
                                    background: "#f59e0b",
                                    color: "#fff",
                                    padding: "10px 20px",
                                    borderRadius: "10px",
                                    border: "none",
                                    fontWeight: "700",
                                    cursor: "pointer"
                                }}
                            >
                                ➕ Add Others
                            </button>
                        </div>

                    </div>

                </div>
                <Footer />
            </div>
        </div>
    );
};

const tableScrollWrapper = {
    maxHeight: "60vh",      // controls scroll height
    overflowY: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "10px"
};
const thStyle = {
    textAlign: "left",
    padding: "8px",
    borderBottom: "1px solid #ddd",
    fontWeight: "600",
};

const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #eee",
};
export default Add_CheckZMCMConveyance;
